module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("1. “He believes in hard war”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_vm._v("2. “I can make Georgia howl!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003"
    }
  }, [_vm._v("3. “I’ll have to harden my heart”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. “The most gigantic pleasure expedition”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. “We never wanted to fight”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. “Our degradation was bitter”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. “I don’t war on women and children”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. “Even the sun seemed to hide its face”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. “An inhuman barbarous proceeding”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. “I’ve got Savannah!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. “A Christmas gift”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. “An almost criminal dislike of the Negro”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. “No such army since the days of Julius Caesar”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. “We’ll destroy no private property”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. “The day of Jubilo has come”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. “For the first time I am ashamed”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. “Death to all foragers”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. “Rebels have no rights”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. “Kilpatrick’s shirt-tail skedaddle”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. “I can whip Joe Johnston”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. “He shall have no rest”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. “They don’t drive worth a damn”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. “Splendid legs! Splendid legs!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. “Who’s doing this surrendering, anyhow?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. “Sherman has fatally blundered”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. “Washington is as corrupt as hell”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. “They march like the lords of the world”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0